import { GreenTechCourse } from './types';

export const GREEN_TECH_COURSES: GreenTechCourse[] = [
  {
    id: 'sustainable-software-engineering',
    title: 'Sustainable Software Engineering',
    description: 'Learn to build environmentally responsible software with carbon-efficient coding practices and green architecture principles.',
    level: 'intermediate',
    totalDuration: '6 hours',
    image: '/api/placeholder/400/300',
    tags: ['Sustainability', 'Green Software', 'Carbon Efficiency', 'Environmental Impact', 'Climate Tech'],
    prerequisites: ['Software development experience', 'Basic understanding of system architecture'],
    estimatedHours: 6,
    objectives: [
      'Understand software\'s environmental impact',
      'Implement carbon-efficient coding practices',
      'Design sustainable software architectures',
      'Measure and reduce digital carbon footprint'
    ],
    learningOutcomes: [
      'Calculate software carbon footprint',
      'Apply green coding principles and patterns',
      'Design energy-efficient algorithms',
      'Optimize resource usage and performance',
      'Implement sustainable CI/CD practices',
      'Create carbon-aware applications'
    ],
    modules: [
      {
        id: 'carbon-footprint-software',
        title: 'Understanding Software Carbon Footprint',
        description: 'Learn how software impacts the environment',
        content: 'Software development and operation contribute significantly to global carbon emissions...',
        duration: '1.5 hours',
        difficulty: 'beginner',
        order: 1,
        estimatedTime: '1.5 hours',
        learningObjectives: [
          'Understand scope 1, 2, and 3 emissions in software',
          'Learn about energy consumption in computing',
          'Identify high-impact areas for optimization'
        ],
        codeExamples: [
          {
            title: 'Carbon Footprint Calculator',
            code: 'class CarbonFootprintCalculator {\n  calculateCPUEmissions(cpuUtilization, duration, powerUsage) {\n    const energyKWh = (cpuUtilization * powerUsage * duration) / 1000;\n    const carbonIntensity = 0.5; // kg CO2/kWh (varies by region)\n    return energyKWh * carbonIntensity;\n  }\n\n  calculateDataTransferEmissions(bytesTransferred) {\n    const kwhPerGB = 0.006; // kWh per GB transferred\n    const gbTransferred = bytesTransferred / (1024 ** 3);\n    return gbTransferred * kwhPerGB * 0.5; // carbon intensity\n  }\n}',
            explanation: 'A simple calculator for estimating software carbon emissions.',
            language: 'javascript'
          }
        ]
      },
      {
        id: 'green-coding-principles',
        title: 'Green Coding Principles and Patterns',
        description: 'Master energy-efficient programming techniques',
        content: 'Learn specific coding practices that reduce energy consumption...',
        duration: '2 hours',
        difficulty: 'intermediate',
        order: 2
      },
      {
        id: 'sustainable-architecture',
        title: 'Sustainable Software Architecture',
        description: 'Design environmentally responsible system architectures',
        content: 'Explore architectural patterns that minimize environmental impact...',
        duration: '1.5 hours',
        difficulty: 'intermediate',
        order: 3
      },
      {
        id: 'carbon-aware-applications',
        title: 'Carbon-Aware Application Development',
        description: 'Build applications that adapt to grid carbon intensity',
        content: 'Create software that responds to real-time carbon data...',
        duration: '1 hour',
        difficulty: 'advanced',
        order: 4
      }
    ],
    type: 'green-tech'
  },
  {
    id: 'green-devops-infrastructure',
    title: 'Green DevOps & Carbon-Efficient Infrastructure',
    description: 'Implement sustainable DevOps practices and optimize infrastructure for minimal environmental impact.',
    level: 'advanced',
    totalDuration: '8 hours',
    image: '/api/placeholder/400/300',
    tags: ['Green DevOps', 'Sustainable Infrastructure', 'Cloud Optimization', 'Energy Efficiency', 'Carbon Reduction'],
    prerequisites: ['DevOps experience', 'Cloud infrastructure knowledge', 'CI/CD understanding'],
    estimatedHours: 8,
    objectives: [
      'Optimize cloud infrastructure for sustainability',
      'Implement green CI/CD pipelines',
      'Monitor and reduce infrastructure emissions',
      'Design carbon-efficient deployment strategies'
    ],
    learningOutcomes: [
      'Configure green cloud infrastructure',
      'Optimize CI/CD for energy efficiency',
      'Implement carbon-aware scaling policies',
      'Monitor infrastructure carbon footprint',
      'Choose sustainable cloud providers and regions',
      'Design disaster recovery with sustainability focus'
    ],
    modules: [
      {
        id: 'green-cloud-infrastructure',
        title: 'Green Cloud Infrastructure Design',
        description: 'Design sustainable cloud architectures',
        content: 'Learn to optimize cloud infrastructure for environmental impact...',
        duration: '2.5 hours',
        difficulty: 'advanced',
        order: 1
      },
      {
        id: 'sustainable-cicd',
        title: 'Sustainable CI/CD Pipelines',
        description: 'Build energy-efficient deployment pipelines',
        content: 'Optimize continuous integration and deployment for sustainability...',
        duration: '2 hours',
        difficulty: 'intermediate',
        order: 2
      },
      {
        id: 'carbon-monitoring',
        title: 'Carbon Footprint Monitoring',
        description: 'Track and analyze infrastructure emissions',
        content: 'Implement monitoring solutions for infrastructure carbon tracking...',
        duration: '1.5 hours',
        difficulty: 'advanced',
        order: 3
      },
      {
        id: 'sustainable-scaling',
        title: 'Carbon-Aware Auto-Scaling',
        description: 'Implement intelligent, sustainable scaling policies',
        content: 'Create scaling strategies that consider carbon intensity...',
        duration: '1.5 hours',
        difficulty: 'advanced',
        order: 4
      },
      {
        id: 'green-disaster-recovery',
        title: 'Sustainable Disaster Recovery',
        description: 'Design eco-friendly backup and recovery strategies',
        content: 'Balance availability requirements with environmental impact...',
        duration: '0.5 hours',
        difficulty: 'advanced',
        order: 5
      }
    ],
    type: 'green-tech'
  }
];